import { type DealApi, type DealState, dealFormField, dealStatus } from '@openx/types/deal';
import { DealParticipantsField } from '../../components/DealParticipants/fields';
import { parseDealDate } from './parseDealDate';

export const mapDealToTemplateDeal = (deal: DealApi | DealState): DealState => {
  const {
    account_uid,
    currency,
    deal_price,
    deal_source,
    deal_supplements,
    enable_dv360_inventory_package,
    end_date,
    lifetime_impression_goal,
    open_auction_access,
    package_uid,
    pmp_deal_type,
    start_date,
    use_market_floor,
    deal_participants = [],
    expected_ad_category,
    rbo_config,
    agency_salesforce_id,
    brand_salesforce_id,
    frequency_capping,
    monetizing_uid,
    third_party_fees_config,
    segment_partner_revenue_method,
    fixed_cpm_enabled,
    pdp_config,
    amazon_config,
  } = deal;

  return {
    [DealParticipantsField.DEAL_PARTICIPANTS]: deal_participants,
    [dealFormField.AMAZON_CONFIG]: amazon_config ?? null,
    [dealFormField.ACCOUNT_UID]: account_uid,
    [dealFormField.AGENCY_SALESFORCE_ID]: agency_salesforce_id,
    [dealFormField.BRAND_SALESFORCE_ID]: brand_salesforce_id,
    [dealFormField.CURRENCY]: currency,
    [dealFormField.DEAL_PRICE]: deal_price,
    [dealFormField.DEAL_SOURCE]: deal_source,
    [dealFormField.DEAL_SUPPLEMENTS]: deal_supplements,
    [dealFormField.ENABLE_DV360_INVENTORY_PACKAGE]: enable_dv360_inventory_package,
    [dealFormField.END_DATE]: parseDealDate(end_date),
    [dealFormField.EXPECTED_AD_CATEGORY]: expected_ad_category,
    [dealFormField.FIXED_CPM_ENABLED]: fixed_cpm_enabled,
    [dealFormField.FREQUENCY_CAPPING]: frequency_capping,
    [dealFormField.IMPRESSION_GOAL]: lifetime_impression_goal,
    [dealFormField.NAME]: '',
    [dealFormField.OPEN_AUCTION_ACCESS]: open_auction_access,
    [dealFormField.PACKAGE_UID]: package_uid,
    [dealFormField.PDP_CONFIG]: pdp_config,
    [dealFormField.PMP_DEAL_TYPE]: pmp_deal_type,
    [dealFormField.RBO_CONFIG]: rbo_config,
    [dealFormField.START_DATE]: parseDealDate(start_date),
    [dealFormField.STATUS]: dealStatus.Active,
    [dealFormField.MONETIZING_UID]: monetizing_uid,
    [dealFormField.USE_MARKET_FLOOR]: use_market_floor,
    third_party_fees_config,
    segment_partner_revenue_method: segment_partner_revenue_method ?? null,
  } as unknown as DealState;
};
